/* eslint-disable */

import AuthorStore from './authorStore';
import CategorylistStore from './CategorylistStore';
import CourseAuthor from './courseAuthor';
import EmailStore from './emailStore';
import InterviewStore from './interviewStore';
import PaymentStore from './PaymentStore';
import QuizStore from './quizStore';
import SearchCourseStore from './SearchCourseStore';
import Vue from 'vue';
import Vuex from 'vuex';
import assignmentStore from './assignmentStore';
import authentication from './authenticate'
import coursesList from './CoursesList';
import createCourses from './CoursesStore';
import userdetailsStore from './UserStore';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    authentication,
    userdetailsStore,
    createCourses,
    coursesList,
    assignmentStore,
    CategorylistStore,
    SearchCourseStore,
    PaymentStore,
    QuizStore,
    AuthorStore,
    CourseAuthor,
    EmailStore,
    InterviewStore
  }
})